import React, { Component } from 'react';
import { Dropdown, Checkbox, Input } from 'semantic-ui-react';
import { EnhancedDropdown } from '../defaultClassComponents.jsx';

export default class ColumnFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: [],
      searchTerm: '',
      filter: false,
      open: false,
    };
  }

  updateColumnState(value, checked) {
    let columns = this.state.columns;

    if (checked) {
      columns.push(value);
    } else {
      columns.splice(columns.indexOf(value), 1);
    }

    this.emitChange(columns);
    this.setState({ columns: columns });
  }

  buildOptions() {
    if (this.state.filter) {
      return [];
    }

    return this.props.options
      .map((opt) => {
        return {
          key: opt.value,
          value: opt.value,
          text: opt.label,
          content: (
            <Checkbox
              defaultChecked={this.state.columns.indexOf(opt.value) > -1}
              label={opt.label}
              onChange={(_e, data) =>
                this.updateColumnState(opt.value, data.checked)
              }
            />
          ),
        };
      })
      .filter((opt) => {
        if (this.state.searchTerm === '') {
          return true;
        }
        return (
          opt.text.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) >
          -1
        );
      });
  }

  emitChange(columns) {
    const options = this.props.options.filter(
      (prop) => columns.indexOf(prop.value) > -1,
    );

    this.props.onChange(
      options.map((opt) => opt.value),
      options.map((opt) => opt.label),
    );
  }

  optionFromValue(value) {
    return this.props.options.filter((opt) => opt.value === value)[0];
  }

  dropdownText() {
    if (this.state.columns.length === 0) {
      return 'Columns';
    }
    if (this.state.columns.length === this.props.options.length) {
      return 'All Selected';
    }

    return 'Column(s) Selected';
  }

  render() {
    return (
      <EnhancedDropdown
        multiple
        direction={'left'}
        open={this.state.open}
        text={this.dropdownText()}
        onBlur={() => this.setState({ open: false })}
        onClick={() => this.setState({ open: !this.state.open })}
      >
        <Dropdown.Menu
          onClick={(e) => {
            this.setState({ open: true });
            e.stopPropagation();
          }}
        >
          <Input
            className='search'
            icon='search'
            iconPosition='left'
            value={this.state.searchTerm}
            onChange={(e) => this.setState({ searchTerm: e.target.value })}
          />

          <Dropdown.Menu scrolling>
            {this.buildOptions().map((option) => (
              <Dropdown.Item
                key={option.key}
                {...option}
              />
            ))}
          </Dropdown.Menu>
        </Dropdown.Menu>
      </EnhancedDropdown>
    );
  }
}
